<app-banner-app [retroSelected]="true"></app-banner-app>
<br><br><br><br><br><br>

<div class="container">
    <br><br>
    <div class="row">
        <div class="col-sm-6 col-md-5 offset-md-2 col-lg-6 offset-lg-0">
            <div class="aliniacionTexto">
                <div class="aliniacionTexto">
                    <img class="styleImage img-responsive" src="./../../assets/img/Candado.png" />
                </div>
            </div>
        </div>

        <div class="col">
            <div class="container" style="text-align: center;">
                <span class="tipografiaCard">Verifica de indentidad</span><br>
                <span class="textoDetalleTipografia">Hemos enviado un código de 6 dígitos al número
                    xxx xxxx097 para validar tu identidad<br>
                    <br><br>
                    3 de 3 intentos restantes
                </span><br><br>
            </div>
            
            <div class="container" style="padding-left: 50px;">
                <span class="textoCodigoVerificacion">Ingresa el código de verificación</span>
                <table>                  
                    <tr>
                        <td>
                            <input type="text" #num1 class="form-control tipoLetra estiloPrincipal"
                                formControlName="num1" id="num1" style="color: #000; height: 60px; width: 60px;">
                        </td>
                        <td>
                            &nbsp;&nbsp;
                        </td>
                        <td>
                            <input type="text" #num2 class="form-control tipoLetra estiloPrincipal"
                                formControlName="num2" id="num2" style="color: #000; height: 60px; width: 60px;">
                        </td>
                        <td>
                            &nbsp;&nbsp;
                        </td>
                        <td>
                            <input type="text" #num3 class="form-control tipoLetra estiloPrincipal"
                                formControlName="num3" id="num3" style="color: #000; height: 60px; width: 60px;">
                        </td>
                        <td>
                            &nbsp;&nbsp;
                        </td>
                        <td>
                            <input type="text" #num4 class="form-control tipoLetra estiloPrincipal"
                                formControlName="num4" id="num4" style="color: #000; height: 60px; width: 60px;">
                        </td>
                        <td>
                            &nbsp;&nbsp;
                        </td>
                        <td>
                            <input type="text" #num5 class="form-control tipoLetra estiloPrincipal"
                                formControlName="num5" id="num5" style="color: #000; height: 60px; width: 60px;">
                        </td>
                        <td>
                            &nbsp;&nbsp;
                        </td>
                        <td>
                            <input type="text" #num6 class="form-control tipoLetra estiloPrincipal"
                                formControlName="num6" id="num6" style="color: #000; height: 60px; width: 60px;">
                        </td>
                    </tr>              
                </table>

                <table>
                    <tr>
                        <td>
                            <span class="textoCincoMunitos">Tu código vence en 05:00 minutos</span>
                        </td>
                        <td style="padding-left: 50px;">
                            <span>
                                <a href="#" class="textoCodigoVerificacion">Reenviar código</a>
                            </span>
                        </td>
                    </tr>
                </table>

            </div>
            <br><br>

            <div style="width: 70%;" class="container">
                <button class="btn btn-primary w-100 py-2 botonContinuar" type="submit">Enviar</button>
            </div>
        </div>
    </div>

</div>

<br><br><br>
<app-footer-app></app-footer-app>